import { render } from "./CalendarIcon.vue?vue&type=template&id=2d00d9c3&scoped=true"
import script from "./CalendarIcon.vue?vue&type=script&lang=js"
export * from "./CalendarIcon.vue?vue&type=script&lang=js"

import "./CalendarIcon.vue?vue&type=style&index=0&id=2d00d9c3&scoped=true&lang=css"

import exportComponent from "D:\\MAMP\\htdocs\\electra\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d00d9c3"]])

export default __exports__